// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {
    Checkbox,
    FormHelperText,
    Input,
    InputLabel,
    Select,
    Stack,
    Tooltip
} from "@mui/material";

// App Imports
import {
    addContractDataPointValue,
    editContractDataPointValue, getCDPVbyCDPid, updateExpressionTranslationAddMode, updateExpressionTranslationEditMode
} from "./ContractDataPointValueClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {getCDPVFbyCDPid} from "../ContractDataPointValueFilter/ContractDataPointValueFilterClient";
import {changeContractDrilldownCDPV} from "../ContractDrilldown/ContractDrilldownCDPV/contractDrilldownSliceCDPV";
import {changeContractDataPoint} from "../ContractDataPoint/contractDataPointSlice";
import {changeContractDataPointValue} from "./contractDataPointValueSlice";
import {changeContractDataPointValueFilter} from "../ContractDataPointValueFilter/contractDataPointValueFilterSlice";
import DynamicCdpvValueField from "../CommonComponents/DynamicCdpvValueField";
import dayjs from "dayjs";
import {changeContractSection} from "../ContractSection/contractSectionSlice";
import {changeContractDrilldownCDPVF} from "../ContractDrilldown/ContractDrilldownCDPVF/contractDrilldownSliceCDPVF";
import CdpvInfoDialogue from "./Info/CdpvInfoDialogue";
import {getAccountHierarchy} from "../ContractDataPoint/ContractDataPointClient";



// Main Function


    export default    function contractDataPointValueForm(){


    // ****************** BEGIN STATES ****************************

    const [showContractDataPointValueDrawer, setShowContractDataPointValueDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);
    const [cdpvFormState, setCdpvFormState] = useState(false);
    const [cdpvExpression, setCdpvExpression] = useState([useSelector((state) => state.contractDataPointValueSlc.value.expression)]);
        const [cdpvInfoOpen, setCdpvInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorContractDataPointValueId = useSelector((state) => state.contractDataPointValueSlc.value.id);
        const selectorCdpvContractDataPointId = useSelector((state) => state.contractDataPointValueSlc.value.contractDataPointId);
        const selectorContractId = useSelector((state) => state.contractSlc.value.id);
        const selectorContractSectionId = useSelector((state) => state.contractDataPointSlc.value. contractSectionId);
    const selectorContractDataPointId = useSelector((state) => state.contractDataPointSlc.value.id);
    const selectorCdpName = useSelector((state) => state.contractDataPointSlc.value.dataPointName);
    const selectorDataPointId = useSelector((state) => state.contractDataPointSlc.value.dataPointId);
    const selectorDataType = useSelector((state) => state.contractDataPointSlc.value.dataType);
    const selectorCdpvCount = useSelector((state) => state.contractDataPointSlc.value.cdpvCount);
    const selectorCdpvfCount = useSelector((state) => state.contractDataPointSlc.value.cdpvfCount);
    const selectorCdpvDrawerState = useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerState);
    const selectorCdpvFormState = useSelector((state) => state.contractDataPointValueSlc.value.cdpvFormState);
    const selectorCdpvDrawerMode = useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerMode);
        const selectorCdpvViewValueOnly = useSelector((state) => state.contractDataPointValueSlc.value.cdpvViewValueOnly);
    const selectorCdpvId = useSelector((state) => state.contractDataPointValueSlc.value.id);
    const selectorCdpvValue = useSelector((state) => state.contractDataPointValueSlc.value.value);
    const selectorCdpvDefaultValue = useSelector((state) => state.contractDataPointValueSlc.value.defaultValue);
    const selectorCdpvOrigin = useSelector((state) => state.contractDataPointValueSlc.value.origin);
    const selectorCdpvOrdinalNumber = useSelector((state) => state.contractDataPointValueSlc.value.ordinalNumber);
    const selectorCdpvIterationNumber = useSelector((state) => state.contractDataPointValueSlc.value.iterationNumber);
    const selectorCdpvExtendInd = useSelector((state) => state.contractDataPointValueSlc.value.extendInd);
        const selectorMockValue = useSelector((state) => state.contractDataPointValueSlc.value.mockValue);
    const selectorCdpvExpression = useSelector((state) => state.contractDataPointValueSlc.value.expression);
    const selectorCdpvExpressionDescription = useSelector((state) => state.contractDataPointValueSlc.value.expressionDescription);
    const selectorCdpvfId = useSelector((state) => state.contractDataPointValueSlc.value.contractDataPointValueFilterId);
        const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorCdpvfGridState = useSelector((state) => state.contractDataPointValueFilterSlc.value.cdpvfGridState);

const [extendFlag, setExtendFlag] = useState(useSelector((state) => state.contractDataPointValueSlc.value.extendInd));

        const [showAccount, setShowAccount] = useState(false);
        const [selectedExpression, setSelectedExpression] = useState();


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    // const {register, handleSubmit} = useForm();
    //     const { register, handleSubmit, setValue } = useForm();
        const {
            register,
            handleSubmit,
            setValue,
            getValues,
        } = useForm({
            shouldUnregister: false,
        });
    // ****************** END REGISTER ****************************

        useEffect(() => {
            setValue('ordinalNumber', selectorCdpvOrdinalNumber);
            setValue('iterationNumber', selectorCdpvIterationNumber);
            setValue('extendInd', selectorCdpvExtendInd);
            setValue('defaultValue', selectorCdpvDefaultValue);
            setValue('expression', selectorCdpvExpression);
            setValue('expressionTranslation', selectorCdpvExpressionDescription);
            setValue('origin', selectorCdpvOrigin);


        }, [
            selectorCdpvOrdinalNumber,
            selectorCdpvIterationNumber,
            selectorCdpvExtendInd,
            selectorCdpvDefaultValue,
            selectorCdpvExpression,
            selectorCdpvExpressionDescription,
            selectorCdpvOrigin,
            setValue
        ]);


        useEffect(() => {
            let formattedValue = selectorCdpvValue;

            if (selectorDataType === 'DATE') {
                if (selectorCdpvValue && selectorCdpvValue.format) {
                    formattedValue = dayjs(selectorCdpvValue).format('MM/DD/YYYY');
                } else if (selectorCdpvValue instanceof Date) {
                    formattedValue = selectorCdpvValue.toLocaleDateString();
                } else if (!selectorCdpvValue) {
                    formattedValue = '';
                }
            }

            setValue('value', formattedValue);
        }, [selectorCdpvValue, selectorDataType, setValue]);


        useEffect(() => {
            let formattedDefaultValue = selectorCdpvDefaultValue;

            if (selectorDataType === 'DATE') {
                if (selectorCdpvDefaultValue && selectorCdpvDefaultValue.format) {
                    formattedDefaultValue = dayjs(selectorCdpvDefaultValue).format('MM/DD/YYYY');
                } else if (selectorCdpvDefaultValue instanceof Date) {
                    formattedDefaultValue = selectorCdpvDefaultValue.toLocaleDateString();
                } else if (!selectorCdpvDefaultValue) {
                    formattedDefaultValue = '';
                }
            }

            setValue('defaultValue', formattedDefaultValue);
        }, [selectorCdpvDefaultValue, selectorDataType, setValue]);


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my contractDataPointValue data to submit");
        console.log({data});
        console.log("here's my stringify data to submit");
        console.log(JSON.stringify(data, null, 2));
        console.log("selectorCdpvValue",{selectorCdpvValue});
        console.log("selectorCdpvDefaultValue",{selectorCdpvDefaultValue});
        if (selectorCdpvDrawerMode === "Add" && ((data.contractDataPointValueFilter.id === null) || (data.contractDataPointValueFilter.id === ''))) {

            addContractDataPointValue(              JSON.parse(JSON.stringify(data, (key, value) => {
                if (key === "contractDataPointValueFilter" ) {
                    return undefined;}
                return value;
            })))

                .then(() => {
                    console.log("ContractDataPointValue added");
                    console.log("data submitted for posting");
                    console.log(data);

                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "success",
                        crudMessage: "Record added"
                    }));

                    console.log("before updateExpressionTranslationAddMode");

                    const result = updateExpressionTranslationAddMode();

                    console.log("after updateExpressionTranslationAddMode");
                    console.log("result =", result);

                    return result;
                })
                .catch(err => {
                    console.error(err);

                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Add failed"
                    }));
                })
                .finally(() => {
                    setSubmitting(false);

                    dispatchData(changeContractDataPoint({
                        cdpDrawerState: false,
                        cdpGridRefresh: true
                    }));

                    dispatchData(changeContractDrilldownCDPV({
                        cdpvGridRefresh: true
                    }));

                    console.log("cdpvGridRefresh = true");

                    dispatchData(changeContractDataPointValue({
                        id: 0,
                        cdpvDrawerContext: "none",
                        cdpvDrawerState: false
                    }));

                    dispatchData(changeContractDrilldownCDPVF({
                        cdpvfGridRefresh: true
                    }));
                });

            //     .then(() => {
            //         console.log("ContractDataPointValue added");
            //         console.log("data submitted for posting")
            //         console.log(data)
            //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
            //         console.log("updating expression translation")
            //         updateExpressionTranslationAddMode();
            //     })
            //     .catch(err => {
            //         console.log(err)
            //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            //     }).finally(() => {
            //     setSubmitting(false);
            //     dispatchData(changeContractDataPoint({
            //         // id: 0,
            //         cdpDrawerState: false, cdpGridRefresh: true
            //     }));
            //     dispatchData(changeContractDrilldownCDPV({cdpvGridRefresh: true}));
            //     console.log("cdpvGridRefresh = true");
            //
            //     dispatchData(changeContractDataPointValue({
            //         // id: 0,
            //         cdpvDrawerContext: "none",
            //         cdpvDrawerState: false
            //     }));
            //     dispatchData(changeContractDrilldownCDPVF({cdpvfGridRefresh: true}));
            // })

        }
        if (selectorCdpvDrawerMode === "Add" && ((data.contractDataPointValueFilter.id !== null) && (data.contractDataPointValueFilter.id !== ''))) {
            addContractDataPointValue(data)
                .then(() => {
                    console.log("ContractDataPointValue added");
                    console.log("data submitted for posting");
                    console.log(data);

                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "success",
                        crudMessage: "Record added"
                    }));

                    console.log("before updateExpressionTranslationAddMode");

                    const result = updateExpressionTranslationAddMode();

                    console.log("after updateExpressionTranslationAddMode");
                    console.log("result =", result);

                    return result;
                })
                .catch(err => {
                    console.error(err);

                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Add failed"
                    }));
                })
                .finally(() => {
                    setSubmitting(false);

                    dispatchData(changeContractDataPoint({
                        cdpDrawerState: false,
                        cdpGridRefresh: true
                    }));

                    dispatchData(changeContractDrilldownCDPV({
                        cdpvGridRefresh: true
                    }));

                    console.log("cdpvGridRefresh = true");

                    dispatchData(changeContractDataPointValue({
                        id: 0,
                        cdpvDrawerContext: "none",
                        cdpvDrawerState: false
                    }));

                    dispatchData(changeContractDrilldownCDPVF({
                        cdpvfGridRefresh: true
                    }));
                });

            //
            // addContractDataPointValue(data)
            //     .then(() => {
            //         console.log("ContractDataPointValue added");
            //         console.log("data submitted for posting")
            //         console.log(data)
            //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
            //     }).catch(err => {
            //     console.log(err)
            //     dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            // }).finally(() => {
            //     setSubmitting(false);
            //     console.log("updating expression translation")
            //     updateExpressionTranslationAddMode();
            //     dispatchData(changeContractDataPoint({
            //         // id: 0,
            //         cdpDrawerState: false, cdpGridRefresh: true
            //     }));
            //     dispatchData(changeContractDrilldownCDPV({cdpvGridRefresh: true}));
            //     console.log("cdpvGridRefresh = true");
            //     dispatchData(changeContractDataPointValue({
            //         id: 0,cdpvDrawerContext: "none",
            //         cdpvDrawerState: false
            //     }));
            //     dispatchData(changeContractDrilldownCDPVF({cdpvfGridRefresh: true}));
            // })
        }

        if (selectorCdpvDrawerMode === "Edit" && ((data.contractDataPointValueFilter.id === null) || (data.contractDataPointValueFilter.id === ''))) {
            editContractDataPointValue(selectorContractDataPointValueId,              JSON.parse(JSON.stringify(data, (key, value) => {
                if (key === "contractDataPointValueFilter" ) {
                    return undefined;}
                return value;
                })))
            // editContractDataPointValue(selectorContractDataPointValueId, cleanedData)
                .then(() => {
                    console.log("ContractDataPointValue edited");
                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "success",
                        crudMessage: "Record edited"
                    }));

                    // return updateExpressionTranslationEditMode(selectorContractDataPointValueId);
                    console.log("before updateExpressionTranslationEditMode");

                    const result = updateExpressionTranslationEditMode(selectorContractDataPointValueId);

                    console.log("after updateExpressionTranslationEditMode");
                    console.log("result =", result);

                    return result;
                })
                .catch(err => {
                    console.error(err);
                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Edit failed"
                    }));
                })
                .finally(() => {
                    setSubmitting(false);
                    dispatchData(changeContractSection({ csGridRefresh: true }));
                    dispatchData(changeContractDataPoint({
                        cdpDrawerState: false,
                        cdpGridRefresh: true
                    }));
                    dispatchData(changeContractDrilldownCDPV({ cdpvGridRefresh: true }));
                    dispatchData(changeContractDataPointValue({
                        cdpvDrawerState: false,
                        cdpvDrawerContext: "none",
                        cdpvDrawerMode: "Edit",
                        cdpvGridState: true
                    }));
                    dispatchData(changeContractDrilldownCDPVF({ cdpvfGridRefresh: true }));
                });
            //
            // editContractDataPointValue(selectorContractDataPointValueId,              JSON.parse(JSON.stringify(data, (key, value) => {
            //     if (key === "contractDataPointValueFilter" ) {
            //         return undefined;}
            //     return value;
            // })))
            //     .then(() => {
            //         console.log("ContractDataPointValue edited");
            //         console.log(data)
            //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
            //         updateExpressionTranslationEditMode(selectorContractDataPointValueId);
            //     })
            //     .catch(err => {
            //         console.log(err)
            //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            //     }).finally(() => {
            //     console.log("updating expression translation")
            //     updateExpressionTranslationEditMode(selectorContractDataPointValueId);
            //     setSubmitting(false);
            //     // setShowContractDataPointValueDrawer(false);
            //     console.log("updating without cdpvf.id");
            //     console.log("cdpv.id" || selectorContractDataPointValueId);
            //     console.log(selectorContractDataPointValueId);
            //     dispatchData(changeContractSection({csGridRefresh: true}));
            //     dispatchData(changeContractDataPoint({
            //         // id: 0,
            //         cdpDrawerState: false, cdpGridRefresh: true
            //     }));
            //     dispatchData(changeContractDrilldownCDPV({cdpvGridRefresh: true}));
            //     console.log("cdpvGridRefresh = true");
            //     dispatchData(changeContractDataPointValue({
            //         // id: 0,
            //         cdpvDrawerState: false, cdpvDrawerContext: "none",cdpvDrawerMode: "Edit", cdpvGridState: true
            //     }));
            //     dispatchData(changeContractDrilldownCDPVF({cdpvfGridRefresh: true}));
            //     })
        }
        if (selectorCdpvDrawerMode === "Edit" && ((data.contractDataPointValueFilter.id !== null) && (data.contractDataPointValueFilter.id !== ''))) {
            editContractDataPointValue(selectorContractDataPointValueId, data)
                .then(() => {
                    console.log("ContractDataPointValue edited");
                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "success",
                        crudMessage: "Record edited"
                    }));

                    // return updateExpressionTranslationEditMode(selectorContractDataPointValueId);
                    console.log("before updateExpressionTranslationEditMode");

                    const result = updateExpressionTranslationEditMode(selectorContractDataPointValueId);

                    console.log("after updateExpressionTranslationEditMode");
                    console.log("result =", result);

                    return result;
                })
                .catch(err => {
                    console.error(err);
                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Edit failed"
                    }));
                })
                .finally(() => {
                    setSubmitting(false);
                    dispatchData(changeContractSection({ csGridRefresh: true }));
                    dispatchData(changeContractDataPoint({
                        cdpDrawerState: false,
                        cdpGridRefresh: true
                    }));
                    dispatchData(changeContractDrilldownCDPV({ cdpvGridRefresh: true }));
                    dispatchData(changeContractDataPointValue({
                        cdpvDrawerState: false,
                        cdpvDrawerContext: "none",
                        cdpvDrawerMode: "Edit",
                        cdpvGridState: true
                    }));
                    dispatchData(changeContractDrilldownCDPVF({ cdpvfGridRefresh: true }));
                });
            //
            //     .then(() => {
            //         console.log("ContractDataPointValue edited");
            //         console.log(data)
            //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
            //         console.log("updating expression translation")
            //         updateExpressionTranslationEditMode(selectorContractDataPointValueId);
            //     }).catch(err => {
            //     console.log(err)
            //     dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            // }).finally(() => {
            //     setSubmitting(false);
            //     console.log("updating expression translation")
            //     updateExpressionTranslationEditMode(selectorContractDataPointValueId);
            //     dispatchData(changeContractDataPoint({
            //         // id: 0,
            //         cdpDrawerState: false, cdpGridRefresh: true
            //     }));
            //     dispatchData(changeContractDrilldownCDPV({cdpvGridRefresh: true}));
            //     console.log("cdpvGridRefresh = true");
            //     dispatchData(changeContractDataPointValue({
            //         // id: 0,
            //         cdpvDrawerState: false, cdpvDrawerContext: "none",cdpvDrawerMode: "Edit", cdpvGridState: true
            //     }));
            //     dispatchData(changeContractSection({csGridRefresh: true}));
            //     dispatchData(changeContractDataPointValueFilter({cdpvfGridRefresh: true}))
            //     console.log("my cdpvf grid should have refreshed")
            //     dispatchData(changeContractDrilldownCDPVF({cdpvfGridRefresh: true}));
            // })
        }

    };

        const handleCdpvInfo = () => {
            setCdpvInfoOpen(true);
        };

        const handleCloseCdpvInfo = () => {
            setCdpvInfoOpen(false);
        };
    // ****************** END CRUD ****************************


    // *********************** BEGIN DROPDOWNS **************************

    const selectedCdpDp = useSelector((state) => state.contractDataPointSlc.value.dataPointId);
    const selectedDataType = useSelector((state) => state.contractDataPointSlc.value.dataType);

    const [valueDropdown, setValueDropdown] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
        const [selectedDefaultValue, setSelectedDefaultValue] = useState(null);

    const [originDropdown, setOriginDropdown] = useState([]);
    const [selectedOrigin, setSelectedOrigin] = useState(null);

    const [filterDropdown, setFilterDropdown] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState(null);

    const [cdpvDropdown, setCdpvDropdown] = useState([]);
    const [selectedCDPV, setSelectedCDPV] = useState(null);
    // const [selectedCDPVRow, setSelectedCDPVRow] = useState(null);
    const selectedCDPVRow = null;

        const [accountDropdown, setAccountDropdown] = useState([]);

    // });



    const fetchDataPointValuesForDropdowns = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setOriginDropdown(data.filter(data => data.dataPointId ===  2188));

                const updatedData = data
                    .filter(item => item.dataPointId === selectedCdpDp);  // Filter based on your criteria

// Create a blank option and add it to the start of the array
                const blankOption = { id: '', name: '' };  // Define the blank row

// Use the unshift() method to add the blankOption to the start of the array
                updatedData.unshift(blankOption);

// Now, set the value dropdown with the updated data
                setValueDropdown(updatedData);

            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchDataPointValuesForDropdowns();
    }, []);

    const renderDataPoints2 = dataPointValues => {
        if (dataPointValues.length <= 0) {
            return "No Data";
        }}

    const fetchFiltersForDropdowns = () =>
        getCDPVFbyCDPid(selectorContractDataPointId)

            .then(data => {
                console.log("filter data");
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setFilterDropdown(data);
            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchFiltersForDropdowns();
    }, []);

    const fetchCdpvForDropdowns = () =>
        getCDPVbyCDPid(selectorContractDataPointId)

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setCdpvDropdown(data);
            })
    useEffect(() => {
        console.log("This is for the cdpv dropdown...");
        fetchCdpvForDropdowns();
    }, []);


        const fetchAccountsForDropdowns = () =>
            getAccountHierarchy(selectorContractId)

                .then(data => {
                    console.log(data);
                    // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                    setAccountDropdown(data);
                    console.log("Accounts data");
                    console.log("Queried contract_id = ", selectorContractId);
                    console.log(data);
                })
        useEffect(() => {
            console.log("This is for the accounts dropdown...");
            fetchAccountsForDropdowns();
        }, []);


        const handleValueChange = (valueEvent) => {
        setSelectedValue(valueEvent.target.value);
        console.log("This is for the selected Value");
        console.log(valueEvent.target.value);
    };

        const handleDefaultValueChange = (valueEvent) => {
            setSelectedDefaultValue(valueEvent.target.value);
            console.log("This is for the selected default Value");
            console.log(valueEvent.target.value);
            // dispatchData(changeContractDataPointValue({defaultValue: valueEvent.target.value}));
        };

    const handleOriginChange = (originEvent) => {
        setSelectedOrigin(originEvent.target.value);
        console.log("This is for the selected Origin");
        console.log(originEvent.target.value);
    };

    const handleFilterChange = (filterEvent) => {
        setSelectedFilter(filterEvent.target.value);
        console.log("This is for the selected Origin");
        console.log(filterEvent.target.value);
    };

    const handleMap = () => {
        setShowAccount(!showAccount);
    }

        const handleAccountChange = (newExpression) => {
            dispatchData(changeContractDataPointValue({expression:
                // pick the data point based on the selected data point ID
                    (
                        selectorDataPointId === 12595 ? "^12571^" : // share
                            selectorDataPointId === 12596 ? "^12571^" : // share
                                selectorDataPointId === 12599 ? "^12478^" : // share
                            selectorDataPointId === 10574 ? "^12466^" : // interest principal
                                selectorDataPointId === 11815 ? "^12466^" : // interest producer's share
                                    selectorDataPointId === 12597 ? "^12531^" : // distribution fee basis
                                        selectorDataPointId === 12598 ? "^12546^" : // overhead fee basis
                                            selectorDataPointId === 12610 ? "^12606^" : // bonus basis
                                              "^12571^")
                    + newExpression}));
            setSelectedExpression(newExpression);
        }


// *********************** END DROPDOWNS **************************


    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    const closeContractDataPointValueDrawer = () => {
        dispatchData(changeContractDataPointValue({
            cdpvDrawerState: false,cdpvDrawerContext: "none", cdpvDrawerMode: selectorCdpvDrawerMode, cdpvViewValueOnly: null}));
    };

    // ****************** END MISC ****************************


    // ****************** BEGIN FORM ****************************



        return(
            <div>
                <CdpvInfoDialogue
                    open={cdpvInfoOpen}
                    onClose={handleCloseCdpvInfo}
                    selectorContractGridAPI={selectorContractGridAPI}
                />
                {/*<h3>{selectorCdpvContractDataPointId}</h3>*/}
                {/*<h3>{selectorCdpvOrigin}</h3>*/}
                <form
                    onSubmit={handleSubmit((data)=>        onSubmit(data))}
                >
                    <Box
                        sx={{width: 800, height: 300, pl: 5}}
                        role="presentation"
                    >
                        {/*<p>DP Name {selectorCdpName}</p>*/}
                        {/*<p>Value {selectorCdpvValue}</p>*/}
                        {/*<p>Mock Value {selectorMockValue}</p>*/}
                        {/*<p>Origin {selectorCdpvOrigin}</p>*/}
                        {selectorContractGridAPI !== "Dashboards" && <h2 style={{
                            paddingLeft: 0,
                            cursor: 'pointer'
                        }}   onClick={() => handleCdpvInfo()}>Contract Data Point Value Form</h2>}
                        {selectorContractGridAPI === "Dashboards" && <h2 style={{
                            paddingLeft: 0,
                            cursor: 'pointer'
                        }}  onClick={() => handleCdpvInfo()}>Returned Value Form</h2>}
                        <h3 onClick={() => closeContractDataPointValueDrawer()}
                            style={{cursor: 'pointer' }}
                        >{selectorCdpName}</h3>
                        <Tooltip enterDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"Contract Data Point ID: " + selectorContractDataPointId +
                        "\nContract Data Point Value ID: " + selectorContractDataPointValueId +
                        "\nContract Data Point Value Count: " + selectorCdpvCount +
                        "\nContract Data Point Value Filter Count: " + selectorCdpvfCount
                    }</span>}>
                            <h4   onClick={() => closeContractDataPointValueDrawer()}
                                  style={{cursor: 'pointer' }}
                            >{selectorCdpvDrawerMode} Mode</h4>
                        </Tooltip>

                        <Input
                            style={{visibility: "hidden"}}
                            {...register('contractDataPoint.id', {required: true})}
                            // type="number"
                            id="contractDataPoint.id" name="contractDataPoint.id" label="contractDataPoint.id"
                            aria-describedby="contractDataPointId_entry"
                            defaultValue={selectorContractDataPointId}
                            sx={{width: 200}}/>

                        {selectorCdpvfCount === 0 &&
                            <Input
                                style={{visibility: "hidden"}}
                                {...register('contractDataPointValueFilter.id', {required: false})}
                                // type="number"
                                id="contractDataPointValueFilter.id" name="contractDataPointValueFilter.id"
                                label="contractDataPointValueFilter.id" aria-describedby="contractDataPointId_entry"
                                defaultValue={selectorCdpvfId}
                                sx={{width: 200}}/>
                        }
                        {selectorCdpvfCount > 0 &&
                            <FormControl variant="standard" sx={{m: 1, minWidth: 600}}>
                                <InputLabel htmlFor="filter">Filter</InputLabel>
                                {/*<Tooltip  enterDelay={1000}  title={"Parent Filter: " + filterItem.parentDataPointName + " = " + filterItem.parentMockValue}>*/}
                                <Select
                                    {...register('contractDataPointValueFilter.id', {required: false})}
                                    labelId="demo-simple-select-filled-filter"
                                    id="filter"
                                    label="Filter"
                                    onChange={handleFilterChange}
                                    defaultValue={selectorCdpvfId}
                                >
                                    {filterDropdown.map((filterItem) =>

                                        <MenuItem sx={{width: "100%"}}
                                                  value={filterItem.id}>{filterItem.parentDataPointName}: {filterItem.parentDisplaySingleValue} {filterItem.parentDisplayFromValue} {filterItem.parentDisplayToValue} {filterItem.dataPointName}: {filterItem.displaySingleValue} {filterItem.displayFromValue} {filterItem.displayToValue}{filterItem.mockValue}{filterItem.expression}

                                        </MenuItem>
                                    )}
                                </Select>
                                {/*</Tooltip>*/}
                                <FormHelperText id="filter_helper">Which filter should this be under?</FormHelperText>
                            </FormControl>}
                        {selectorCdpvViewValueOnly &&
                            <Box
                                sx={{ height: 350}}
                                 />
                        }
                        {!selectorCdpvViewValueOnly &&
                            <div>
                                <Box>
                                <InputLabel htmlFor="ordinalNumber">Order</InputLabel>
                                <Input
                                    {...register('ordinalNumber', {required: false})}
                                    id="ordinalNumber" name="ordinalNumber" label="Order"
                                    aria-describedby="ordinalNumber_entry"
                                    defaultValue={selectorCdpvOrdinalNumber}
                                />
                                {/*<FormHelperText id="ordinalNumber_helper">if multiple, enter where in the order</FormHelperText>*/}
                            </Box>


                            <br/>
                            <Stack direction="row" spacing={2}>
                                <Box>
                                    <InputLabel htmlFor="iterationNumber">Iteration Number</InputLabel>
                                    <Input
                                        {...register('iterationNumber', {required: false})}
                                        id="iterationNumber" name="iterationNumber" label="Iteration Number"
                                        aria-describedby="iterationNumber_entry"
                                        defaultValue={selectorCdpvIterationNumber}
                                    />
                                    {/*<FormHelperText id="iterationNumber_helper">enter an iteration number</FormHelperText>*/}
                                </Box>

                                <Box>

                                    <Checkbox
                                        checked={extendFlag}
                                        onClick={() => setExtendFlag(!extendFlag)}
                                        {...register('extendInd', {required: false})}
                                        id="extendInd" name="extendInd" label="extendInd"
                                        aria-describedby="extendInd_entry"
                                        //          defaultValue=        {selectorCdpvExtendInd}
                                        sx={{width: 300}}/>
                                    <FormHelperText id="extendInd_helper">check here if this is the last iteration and
                                        it should repeat forever</FormHelperText>
                                </Box>
                            </Stack>
                            {/*<br/>*/}
                            <br/>
                        </div>}
                        <Stack direction="row" spacing={2}>
                            <Box>
                                <DynamicCdpvValueField
                                    selectorDataPointId={selectorDataPointId}
                                    selectorValue={selectorCdpvValue}
                                    selectorDataType={selectorDataType}
                                    selectorContext={"ContractDataPointValueFormValue"}
                                    selectorLabel={"Value"}
                                />
                                {!selectorCdpvViewValueOnly &&
                                <FormHelperText id="value_helper">(leave blank if value comes from user or
                                    logic)</FormHelperText>
                                }
                            </Box>
                            {!selectorCdpvViewValueOnly &&
                            <Box>
                                <DynamicCdpvValueField
                                    selectorDataPointId={selectorDataPointId}
                                    selectorValue={selectorCdpvDefaultValue}
                                    selectorDataType={selectorDataType}
                                    selectorContext={"ContractDataPointValueFormDefaultValue"}
                                    selectorLabel={"Default Value"}
                                />
                                <FormHelperText id="default_value_helper"></FormHelperText>
                            </Box>
                            }
                        </Stack>
                        {!selectorCdpvViewValueOnly &&
                        <div>
                            <br/>
                            <br/>

                            <Stack direction="row"  alignItems="center"><InputLabel htmlFor="expression">Expression </InputLabel>
                                {selectorDataType === "DOLLARS" && <Button onClick={() => handleMap()}>MAP</Button>}
                                {showAccount &&
                                    <div>
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}
                                        >
                                            <InputLabel>Map To Account</InputLabel>
                                            <Select
                                                id="account_id"
                                                value= {selectedExpression}
                                                label="Accounts"
                                                onChange={(event) => handleAccountChange(event.target.value)}
                                            >
                                                {accountDropdown.map((accountItem) =>
                                                    <MenuItem
                                                        value={accountItem.expressionText}
                                                        sx={{
                                                            fontWeight: accountItem.hierarchyLevel === 1 ? 'bold' : 'normal',
                                                            pl: accountItem.hierarchyLevel * 2 }}
                                                    >{accountItem.accountName}</MenuItem>
                                                )

                                                }
                                            </Select>
                                            {/*<FormHelperText id="value_helper">select the account to which you want to map this data point</FormHelperText>*/}
                                        </FormControl>
                                    </div>
                                }
                            </Stack>
                            <Input sx={{width: "90%"}}
                                   {...register('expression', {required: false})}
                                   id="expression" name="expression" label="Expression"
                                   aria-describedby="expression_entry"
                                   defaultValue={selectorCdpvExpression}
                                // defaultValue={cdpvExpression}
                            />
                            <FormHelperText id="expression_helper">enter any logic that will generate the
                                value</FormHelperText>
                            <br/>
                            <br/>
                            <InputLabel htmlFor="expressionDescription">Expression Description</InputLabel>
                            <Input sx={{width: "90%"}}
                                   {...register('expressionDescription', {required: false})}
                                   id="expressionDescription" name="expressionDescription" label="ExpressionDescription"
                                   aria-describedby="expressionDescription_entry"
                                   defaultValue={selectorCdpvExpressionDescription}
                            />
                            <FormHelperText id="expressionDescription_helper">enter a description of what the logic
                                does</FormHelperText>
                            <br/>
                            <FormControl variant="standard" sx={{m: 1, minWidth: 120}}>
                                <InputLabel htmlFor="origin">Origin</InputLabel>
                                <Select
                                    {...register('origin', {required: true})}
                                    labelId="demo-simple-select-filled-label2"
                                    id="origin"
                                    label="Data Point Value"
                                    onChange={handleOriginChange}
                                    defaultValue={selectorCdpvOrigin}

                                >
                                    {originDropdown.map((originItem) => (
                                        <MenuItem
                                            key={originItem.id}
                                            sx={{ width: "50%" }}
                                            value={originItem.name}
                                        >
                                            <Tooltip
                                                title={originItem.description || ""}
                                                placement="right"
                                                enterDelay={1000}
                                            >
                                                <span>{originItem.name}</span>
                                            </Tooltip>
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText id="origin_helper">Where will this data come from?</FormHelperText>
                            </FormControl>

                            <Input style={{visibility: "hidden"}}
                                   {...register('partitionKey', {required: false})}
                                   id="partitionKey" name="partitionKey" label="partitionKey"
                                   aria-describedby="partitionKey_entry"
                                   value="Master"
                            />

                        </div>
                        }
                        <br/>
                        {selectorCdpvViewValueOnly &&
                            <Box
                                sx={{ height: 40}}
                            />
                        }
                        <Button
                            type="submit"
                        >Submit</Button>
                        <Button onClick={() => closeContractDataPointValueDrawer()}>Cancel</Button>
                        {/*</div>}*/}

                    </Box>

                </form>
            </div>
        );

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input
                    style={{ visibility: "hidden" }}
                    {...register('expressionTranslation', { required: false })}
                    id="expressionTranslation" name="expressionTranslation"  label="Expression Translation" aria-describedby="expressionTranslation_entry"
                    defaultValue=        {useSelector((state) => state.contractDataPointValueSlc.value.expressionTranslation)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointValueSlc.value.status)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('mockValue', { required: false })}
                       id="mockValue" name="mockValue"  label="mockValue" aria-describedby="mockValue_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointValueSlc.value.mockValue)}
                />

                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointValueSlc.value.createdBy)}
                />

                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointValueSlc.value.lastModifiedBy)}
                />

                <Input style={{ visibility: "hidden" }}
                       {...register('partitionKey', { required: false })}
                       id="partitionKey" name="partitionKey"  label="partitionKey" aria-describedby="partitionKey_entry"
                       value= "Master"
                />

            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************

}
